// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"ContactsGrid_gridContainer__1353S","gridOverlay":"ContactsGrid_gridOverlay__3fxff"};